import { Facility } from '../types/schema';

export const formatAddress = (facility?: Facility) =>
  `${facility?.address?.street_number} ${facility?.address?.route} ${facility?.address?.locality}, ${facility?.address?.administrative_area_level_1}, ${facility?.address?.postal_code}`;

export const getGoogleMapLink = (facility?: Facility) =>
  encodeURI(
    `https://www.google.com/maps/search/?api=1&query=${facility?.address?.latitude},${facility?.address?.longitude}`,
  );
